import { render, staticRenderFns } from "./MoveTo.vue?vue&type=template&id=b0458c02&scoped=true"
import script from "./MoveTo.vue?vue&type=script&setup=true&lang=js"
export * from "./MoveTo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MoveTo.vue?vue&type=style&index=0&id=b0458c02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0458c02",
  null
  
)

export default component.exports